import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import PendingComp from 'admin/components/application/PendingComp';
import AdminSidebar from 'admin/sidebar/AdminSidebar';
import { ToastContainer, toast } from 'react-toastify';
import NoDataImage from '../../../assets/images/PurpleIcon.png';
import { formatDate, formatTimeInTimezone } from 'pages/utils/formdatedynamics';
import 'admin/packages/SuperAdminPackages.css';

const SkeletonRow = ({ index }) => (
  <tr style={{ borderBottom: '1px solid #f0f0f5', background: index % 2 === 0 ? '#fff' : '#fafafa' }}>
    <td style={td}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <div className="ap-skel" style={{ width: 32, height: 32, borderRadius: 8 }} />
        <div className="ap-skel" style={{ width: 120, height: 12 }} />
      </div>
    </td>
    <td style={td}><div className="ap-skel" style={{ width: 150, height: 11 }} /></td>
    <td style={td}><div className="ap-skel" style={{ width: 110, height: 11 }} /></td>
    <td style={td}><div className="ap-skel" style={{ width: 100, height: 26, borderRadius: 8 }} /></td>
    <td style={td}><div className="ap-skel" style={{ width: 40, height: 22, borderRadius: 20 }} /></td>
  </tr>
);

function Approved() {
  const navigte = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedItem, setSelectedItem] = useState(null);
  const [terminating, setTerminating] = useState(null);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem('accessTokenAdmin');
      try {
        const response = await axios.get('https://production.washta.com/api/admin/businessBystatus?status=approved', {
          headers: { Authorization: `Bearer ${token}` },
        });
        setData(response.data.data.reverse());
      } catch (err) {
        if (err.response?.status === 401) { localStorage.clear(); navigte('/'); }
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [navigte]);

  const handleTerminate = async (id) => {
    if (!window.confirm('Are you sure you want to terminate this seller?')) return;
    setTerminating(id);
    try {
      await axios.patch(`https://production.washta.com/api/admin/businessTerminate/${id}`, {}, {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessTokenAdmin')}` },
      });
      toast.success('Successfully terminated');
      setData(prev => prev.filter(item => item._id !== id));
      if (selectedItem?._id === id) setSelectedItem(null);
    } catch (err) {
      toast.error('Failed to terminate');
    } finally {
      setTerminating(null);
    }
  };

  const rows = (data || []).filter(item => item.email && item.username);

  return (
    <div className='mainDiv-all-sideBar'>
      <div className='div-sidebar'><AdminSidebar /></div>
      <div className='div-Dashbaord'>
        <h1 className='h1-all-heading'>Approved Applications</h1>
        <div className="dashboard">
          {loading ? (
            <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fff', borderRadius: 12, overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.07)' }}>
              <thead>
                <tr style={{ background: '#f5f4fb', borderBottom: '1px solid #ececf3' }}>
                  <th style={th}>Provider</th>
                  <th style={th}>Email</th>
                  <th style={th}>Date</th>
                  <th style={th}>Documents</th>
                  <th style={th}>Action</th>
                </tr>
              </thead>
              <tbody>
                {Array.from({ length: 6 }).map((_, i) => <SkeletonRow key={i} index={i} />)}
              </tbody>
            </table>
          ) : rows.length === 0 ? (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <img src={NoDataImage} alt="No Data" style={{ maxWidth: '50%', objectFit: 'contain' }} />
            </div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fff', borderRadius: 12, overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.07)' }}>
              <thead>
                <tr style={{ background: '#f5f4fb', borderBottom: '1px solid #ececf3' }}>
                  <th style={th}>Provider</th>
                  <th style={th}>Email</th>
                  <th style={th}>Date</th>
                  <th style={th}>Documents</th>
                  <th style={th}>Action</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((item, index) => (
                  <tr key={item._id} style={{ borderBottom: '1px solid #f0f0f5', background: index % 2 === 0 ? '#fff' : '#fafafa' }}>
                    <td style={td}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <img
                          src={item.business?.businessImage || NoDataImage}
                          alt=""
                          style={{ width: 32, height: 32, borderRadius: 8, objectFit: 'cover' }}
                        />
                        <span style={{ fontWeight: 600, fontSize: 13, color: '#1c1c28' }}>{item.business?.companyName || item.username}</span>
                      </div>
                    </td>
                    <td style={{ ...td, color: '#666', fontSize: 12 }}>{item.email}</td>
                    <td style={{ ...td, color: '#888', fontSize: 12 }}>
                      {formatDate(item.business?.cratedAt)} {item.business?.cratedAt ? `At ${formatTimeInTimezone(item.business.cratedAt)}` : ''}
                    </td>
                    <td style={td}>
                      <button style={viewBtn} onClick={() => setSelectedItem(item)}>View Documents</button>
                    </td>
                    <td style={td}>
                      <button
                        className={`sap-toggle on`}
                        style={{ opacity: terminating === item._id ? 0.5 : 1, cursor: terminating === item._id ? 'not-allowed' : 'pointer' }}
                        disabled={terminating === item._id}
                        title="Active — click to terminate"
                        onClick={() => handleTerminate(item._id)}
                      >
                        <span className="sap-toggle-knob" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {selectedItem && (
        <PendingComp
          data={selectedItem}
          location={selectedItem.business?.location}
          document={selectedItem.business?.uploadDocument}
          show={false}
          ViewDocument="View Documents"
          name={selectedItem.business?.companyName || selectedItem.username}
          date={selectedItem.business?.cratedAt}
          time={selectedItem.business?.time}
          email={selectedItem.email}
          valNumber={selectedItem.business?.VATNumber}
          Ceo={selectedItem.business?.position}
          showBtn={false}
          TextPopupbtnLast="Terminate Seller"
          TextpopupbtnHandle={() => handleTerminate(selectedItem._id)}
          _forceOpen
          _onPopupHide={() => setSelectedItem(null)}
        />
      )}

      <ToastContainer />

      {/* Skeleton shimmer animation (scoped, no CSS file edit needed) */}
      <style>{`
        .ap-skel {
          border-radius: 6px;
          background: linear-gradient(90deg, #f0f0f4 25%, #e4e4ee 37%, #f0f0f4 63%);
          background-size: 400% 100%;
          animation: apSkeletonShimmer 1.4s ease infinite;
        }
        @keyframes apSkeletonShimmer {
          0% { background-position: 100% 50%; }
          100% { background-position: 0 50%; }
        }
      `}</style>
    </div>
  );
}

const th = { padding: '10px 16px', textAlign: 'left', fontSize: 11, fontWeight: 700, color: '#888', textTransform: 'uppercase', letterSpacing: '0.06em' };
const td = { padding: '12px 16px', verticalAlign: 'middle' };
const viewBtn = { fontSize: 12, fontWeight: 600, padding: '6px 14px', borderRadius: 8, border: '1px solid #d8d2ff', background: '#f5f4fb', color: '#6b5fe4', cursor: 'pointer' };

export default Approved;
